import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_API_KEY = 'opportunityBoard';

export function useInfiniteBoardsQuery({
	pageSize = 50,
	sort = 'asc',
	type,
	expand,
	refetchOnWindowFocus = false,
	meta,
	impersonationContext,
}: {
	pageSize?: number;
	sort?: 'asc' | 'desc';
	type: string;
	expand?: string;
	refetchOnWindowFocus?: boolean;
	meta?: LevStandardQueryMeta;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	// Use impersonationContext from props if provided, otherwise fall back to userSession
	const effectiveImpersonationContext = impersonationContext ?? userSession?.impersonationContext;
	return useInfiniteQuery<Api.IPagedCollection<Api.IBoard>>({
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: ({ pageParam }) =>
			userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.IBoard>>(
				Api.ImpersonationBroker.composeApiUrl({
					queryParams: {
						pageSize,
						pageToken: pageParam,
						sort,
						type: encodeURIComponent(type),
						...(expand ? { expand } : {}),
					},
					urlPath: `board`,
					impersonationContext: effectiveImpersonationContext,
				}),
				'GET'
			),
		queryKey: [BASE_API_KEY, type, sort, pageSize, effectiveImpersonationContext?.account?.id, expand],
		refetchOnWindowFocus,
		initialPageParam: '',
		meta,
	});
}

export const invalidateBoardsQuery = () => {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_API_KEY] });
};
